import { useEffect } from "react";
import { useMap } from "react-map-gl";

export default function useCtrlDragRotate() {
    const map = useMap().map!;

    useEffect(() => {
        if (!map) return;

        const canvas = map.getMap().getCanvasContainer();

        const onMouseDown = (e: MouseEvent) => {
            if (e.button === 2)
                e.ctrlKey ? map.getMap().dragRotate.enable() : map.getMap().dragRotate.disable();
        };

        canvas.addEventListener("mousedown", onMouseDown, { capture: true });
        return () => canvas.removeEventListener("mousedown", onMouseDown, { capture: true });
    }, [map]);
}
